import styled from '@emotion/styled/macro';

import { FormNumericInput } from '../../../../UI/Form/FormNumericInput/FormNumericInput';

export const StyledFormNumericInput = styled(FormNumericInput)`
  width: auto;
`;
